module.exports = __webpack_public_path__ + "static/media/category-unmarked.4cb6eb34.svg";